import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../constants/config";

const GD = "#8B6914";
const GDH = "#D4AF37";
const GDL = "#A07828";
const BG = "#FDFBF7";

const TYPE_LABEL = {
  retreat: "闭关", empowerment: "灌顶", puja: "法会",
  teaching: "课程", weekly_practice: "共修", ceremony: "法会",
};

function Lightbox({ images, index, onClose, onPrev, onNext }) {
  if (!images || images.length === 0) return null;
  const url = images[index];
  const hasPrev = index > 0;
  const hasNext = index < images.length - 1;
  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, zIndex: 2000,
      background: "rgba(0,0,0,0.92)", display: "flex",
      alignItems: "center", justifyContent: "center",
      cursor: "pointer",
    }}>
      <button onClick={e => { e.stopPropagation(); onClose(); }} style={{
        position: "absolute", top: 20, right: 24,
        background: "none", border: "none", color: "#fff",
        fontSize: 28, cursor: "pointer", opacity: 0.7,
      }}>✕</button>
      {hasPrev && (
        <button onClick={e => { e.stopPropagation(); onPrev(); }} style={{
          position: "absolute", left: 16, top: "50%", transform: "translateY(-50%)",
          background: "rgba(255,255,255,0.1)", border: "none", color: "#fff",
          fontSize: 32, cursor: "pointer", borderRadius: 8, padding: "8px 14px",
        }}>‹</button>
      )}
      <img src={url} alt=""
        onClick={e => e.stopPropagation()}
        style={{
          maxWidth: "90vw", maxHeight: "85vh",
          borderRadius: 8, objectFit: "contain",
          cursor: "default",
        }} />
      {hasNext && (
        <button onClick={e => { e.stopPropagation(); onNext(); }} style={{
          position: "absolute", right: 16, top: "50%", transform: "translateY(-50%)",
          background: "rgba(255,255,255,0.1)", border: "none", color: "#fff",
          fontSize: 32, cursor: "pointer", borderRadius: 8, padding: "8px 14px",
        }}>›</button>
      )}
      <div style={{ position: "absolute", bottom: 20, color: "rgba(255,255,255,0.5)", fontSize: 12 }}>
        {index + 1} / {images.length}
      </div>
    </div>
  );
}

export default function HistoricalGalleryPage({ lang: langProp }) {
  const lang = langProp || localStorage.getItem("lumina_lang") || "zh";
  const L = (zh, en) => lang === "zh" ? zh : en;
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [member, setMember] = useState(null);
  const [lightbox, setLightbox] = useState(null); // { eventIdx, imgIdx }

  useEffect(() => {
    const token = localStorage.getItem("vajra_token");
    if (token) {
      fetch(`${API}/vajra/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (d) setMember(d); })
        .catch(() => {});
    }
  }, []);

  useEffect(() => {
    fetch(`${API}/vajra/gallery/events`)
      .then(r => r.ok ? r.json() : [])
      .then(data => { setEvents(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const handleLogout = () => { localStorage.removeItem("vajra_token"); setMember(null); };

  return (
    <div style={{ minHeight: "100vh", background: BG }}>
      {/* Header */}
      <div style={{
        position: "sticky", top: 0, zIndex: 100,
        background: "rgba(253,251,247,0.92)", backdropFilter: "blur(16px)",
        borderBottom: "1px solid rgba(212,175,55,0.25)",
        padding: "0 24px", height: 56, display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <button onClick={() => navigate("/vajra")} style={{
          display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", cursor: "pointer", padding: 0,
        }}>
          <span style={{ color: GD, fontSize: 18 }}>☸</span>
          <div>
            <div style={{ color: GD, fontSize: 14, letterSpacing: 3 }}>{L("如意宝金刚社群","BTF Canada Vajra Community")}</div>
            <div style={{ color: "#6B4C3B", fontSize: 9, letterSpacing: 2, opacity: 0.8 }}>BTF CANADA</div>
          </div>
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {member ? (
            <>
              <span style={{ fontSize: 12, color: "#6B4C3B" }}>{member?.dharma_name || member?.name}</span>
              <button onClick={handleLogout}
                style={{ background: "none", border: "none", color: "#6B4C3B", fontSize: 11, cursor: "pointer", textDecoration: "underline", padding: 0 }}>
                {L("退出","Sign Out")}
              </button>
            </>
          ) : (
            <button onClick={() => navigate("/vajra")} style={{
              background: `linear-gradient(135deg,${GD},${GDL})`, border: "none", borderRadius: 8,
              color: "#fff", fontSize: 12, padding: "7px 20px", cursor: "pointer", letterSpacing: 1,
            }}>{L("登录 / 注册","Login / Register")}</button>
          )}
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "40px 20px 80px" }}>
        <h1 style={{ fontSize: 26, fontWeight: 700, color: "#064E3B", marginBottom: 6 }}>
          📸 {L("往期法会回顾","Historical Gallery")}
        </h1>
        <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 36 }}>
          {L("以法会为分类，回顾如意宝金刚社群的珍贵瞬间","Browse precious moments from past dharma events of the BTF Canada Vajra Community")}
        </p>

        {loading && (
          <div style={{ textAlign: "center", paddingTop: 80, color: "#9ca3af" }}>{L("加载中…","Loading…")}</div>
        )}

        {!loading && events.length === 0 && (
          <div style={{ textAlign: "center", paddingTop: 80 }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>📸</div>
            <div style={{ color: "#9ca3af", fontSize: 15, marginBottom: 8 }}>
              {L("暂无往期法会照片","No event photos yet")}
            </div>
            <div style={{ color: "#d1d5db", fontSize: 12 }}>
              {L("照片将在法会结束后陆续上传","Photos will be uploaded after events conclude")}
            </div>
          </div>
        )}

        {events.map((ev, evIdx) => (
          <div key={ev.id} style={{ marginBottom: 48 }}>
            {/* Event header */}
            <div style={{
              display: "flex", alignItems: "baseline", gap: 12,
              marginBottom: 16, flexWrap: "wrap",
            }}>
              <span style={{
                fontSize: 10, letterSpacing: 1.5, padding: "2px 10px", borderRadius: 10,
                background: "rgba(212,175,55,0.08)", color: GDH,
                border: "1px solid rgba(212,175,55,0.15)",
              }}>
                {TYPE_LABEL[ev.event_type] || ev.event_type}
              </span>
              <h2 style={{
                fontSize: 18, fontWeight: 600, color: "#1a1a1a",
                cursor: "pointer", margin: 0,
              }} onClick={() => navigate(`/events/${ev.slug}`)}>
                {ev.title_zh}
              </h2>
              {ev.start_date && (
                <span style={{ fontSize: 12, color: "#9ca3af" }}>
                  📅 {ev.start_date}{ev.end_date && ev.end_date !== ev.start_date ? ` ~ ${ev.end_date}` : ""}
                </span>
              )}
              {ev.teacher_zh && (
                <span style={{ fontSize: 12, color: GD }}>🪷 {ev.teacher_zh}</span>
              )}
            </div>

            {/* Gallery grid */}
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
              gap: 10,
            }}>
              {(ev.gallery_images || []).map((url, imgIdx) => (
                <div key={imgIdx} style={{
                  position: "relative", overflow: "hidden",
                  borderRadius: 10, cursor: "pointer",
                  aspectRatio: "4/3",
                  border: "1px solid rgba(0,0,0,0.06)",
                  background: "#f3f4f6",
                }} onClick={() => setLightbox({ eventIdx: evIdx, imgIdx })}>
                  <img src={url} alt={`${ev.title_zh} ${imgIdx + 1}`}
                    style={{
                      width: "100%", height: "100%", objectFit: "cover",
                      transition: "transform 0.3s",
                    }}
                    onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"}
                    onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <Lightbox
          images={events[lightbox.eventIdx]?.gallery_images || []}
          index={lightbox.imgIdx}
          onClose={() => setLightbox(null)}
          onPrev={() => setLightbox(l => ({ ...l, imgIdx: Math.max(0, l.imgIdx - 1) }))}
          onNext={() => setLightbox(l => {
            const max = (events[l.eventIdx]?.gallery_images || []).length - 1;
            return { ...l, imgIdx: Math.min(max, l.imgIdx + 1) };
          })}
        />
      )}
    </div>
  );
}
